import * as React from "react";
import Layout from "./Layout";
import { Container, Link, Typography } from "@mui/material";
import Results from "./Results";

const CeskaVesPage = () => {
    return (
        <Layout>
            <Container maxWidth={"md"}>
                <Typography component="h1" variant="h2">
                    Z Čertových kamenů do České Vsi
                </Typography>
                <Typography variant={"h4"} component={"h2"} gutterBottom>
                    1. segment - červen
                </Typography>
                <ul>
                    <li>
                        <Link href={"https://www.strava.com/segments/23217061"}>
                            Segment na webu STRAVA
                        </Link>
                    </li>
                    <li>
                        <Link href={"https://www.relive.cc/view/vYvE9JLpjGv"}>
                            Video ukázka
                        </Link>
                    </li>
                </ul>
                <Typography>
                    Začínáme z kopce dolů! Tedy je třeba po zimním „spánku“
                    získat trošku rychlost a jak se nám to podaří? Z kopce to
                    jde skoro samo. Navíc pro Vás máme krásnou trasu, která
                    začíná po čertech dobrém místě – Čertovy kameny.
                </Typography>
                <Typography>
                    Máte tak možnost doběhnout z Jeseníku, nebo parkovat u OÚ v
                    České Vsi a tedy vyrazit na start po svých. Je vhodné
                    obzvlášť pro tuto etapu zahřát tělo a dobře se rozcvičit.
                    Bude Vás čekat běh plný zatáček přeskoků a změny rytmu.
                </Typography>
                <ul>
                    <li>
                        START – segment se Vám bude započítávat v momentě kdy
                        vyrazíte z křižovatky turistických značek dolů na modrou
                        značku (viz obrázek níže).
                    </li>
                    <li>
                        Celou měřenou akci poběžíte/půjdete po modré – velmi
                        dobře značené trase. V klíčových momentech se držte
                        značek a využívejte hlavní trasy bez zkratek. Mohli
                        byste mít problém s načtením do našeho systému, pokud
                        nepůjdete po základní trase. Přikládáme video i obrázek
                        tratě.
                    </li>
                    <li>
                        Cíl po 2,4 dlouhé trase na Vás čeká u obecního úřadu v
                        České Vsi. Mělo by to být na chodníku u hlavní cesty v
                        místě vstupu do OÚ.
                    </li>
                </ul>
                <Results segmentId={"3-1-23217061"} />
            </Container>
        </Layout>
    );
};

export default CeskaVesPage;
